/**
 * cookie中保存语言类型的key
 */
export var langCookieKey = 'lang';
/**
 * 语言列表
 */
export var LanguageList = ['en-GB', 'zh-CN', 'zh-HK'];
/**
 * 官网语言列表
 */
export var OfficialLanguageMap = {
    en: 'en-GB',
    tc: 'zh-HK',
    sc: 'zh-CN',
};
